
import { computed, defineComponent, onMounted, ref } from 'vue';
import { useDeviceSize } from 'SharedDir/common/composables/useDeviceSize';
import { usePublicStatistics } from 'PortalDir/modules/Main/components/Statistics/composables/usePublicStatistics';
import DigitCounter from 'SharedComponents/ui/DigitCounter.vue';
import { useAppStore } from 'stores/app';

export default defineComponent({
  name: 'IssueList',
  components: { DigitCounter },

  setup() {
    const appStore = useAppStore();
    const issueDepList = computed(() => {
      return appStore.issuePublicList;
    });

    const isSsr = computed(() => {
      return appStore.isMainSsrLoad;
    });

    const { getIssuesList } = usePublicStatistics();
    const { isMobile } = useDeviceSize();
    const statisticTitle: string = 'Предоставлено мер поддержки';
    const list = ref<any>([]);

    const countIssues = computed(() => {
      if (issueDepList.value.length !== 0) {
        return issueDepList.value
          .map((x) => x?.count)
          .reduce((accumulator, currentValue) => accumulator + currentValue, 0);
      }
      return 0;
    });

    onMounted(async () => {
      // list.value = await getIssuesList({
      //   groupBy: null,
      //   isCompleted: null,
      // });
      appStore.setIssuePublicList(list.value);
      await appStore.setMainSsrLoad(false);
    });

    return { issueDepList, isMobile, statisticTitle, countIssues, isSsr };
  },
});
